class Cache {
  private static instance: Cache;

  private cache = new Map();

  constructor() {
    if (Cache.instance) {
      return Cache.instance;
    }

    Cache.instance = this;
  }

  set(key: string, value: any, ttl = 300000) {
    const expires = new Date().getTime() + ttl;
    this.cache.set(key, { value, expires });
  }

  async get(key: string) {
    const cachedItem = this.cache.get(key);

    if (!cachedItem) {
      return null;
    }

    if (cachedItem && cachedItem?.expires > new Date().getTime()) {
      return cachedItem.value;
    }

    if (cachedItem) {
      this.cache.delete(key);
    }

    return null;
  }

  clear(key: string) {
    this.cache.delete(key);
  }

  clearAll() {
    this.cache.clear();
  }

  keys() {
    return this.cache.keys();
  }
}

const instance = new Cache();

export default instance;
